import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import { defineComponent, reactive, computed, ref, onBeforeUnmount } from 'vue';
import { ItemService } from '@/services/item.service';
import { useService } from '@kaokei/use-vue-service';
import { useRouter } from 'vue-router';
import ExamInfoModal from '@/components/ExamInfoModal.vue';
import ScienceFair from './ScienceFair.vue';
import { LoginService } from '@/services/login.service';
import { UserService } from '@/services/user.service';
import { CaretRightOutlined } from '@ant-design/icons-vue';
import { environment, isInIframe } from '@/utils/environment';
import { preloadIDE, SHOW_BRAND } from '@/utils';
import moment from 'moment';
export default defineComponent({
  name: 'ItemDetailBanner',
  components: {
    ExamInfoModal: ExamInfoModal,
    ScienceFair: ScienceFair,
    CaretRightOutlined: CaretRightOutlined
  },
  props: {
    height: {
      type: Number,
      default: 984
    }
  },
  setup: function () {
    var userService = useService(UserService);
    var loginService = useService(LoginService);
    var itemService = useService(ItemService);
    var router = useRouter();
    var scienceFairShowFlag = ref(false);
    var examInfo = reactive({
      userExamId: 0,
      visible: false,
      contestId: 0
    });
    var hideGetCertification = environment === 'production' ? itemService.item.contestId === 797 : itemService.item.contestId === 36;
    var shangdongSpecialActive = environment === 'production' ? [1093, 830].includes(itemService.item.contestId) : [187, 233].includes(itemService.item.contestId);
    var chongqinSpecialActive = environment === 'production' ? itemService.item.contestId === 855 : [209, 210].includes(itemService.item.contestId);
    var hideInfoSpecialActive = environment === 'production' ? [1337].includes(itemService.item.contestId) : [264].includes(itemService.item.contestId);
    var showExamInfo = function (item) {
      if (item.userExamId) {
        preloadIDE(); // 预加载ide
        examInfo.userExamId = item.userExamId;
        examInfo.visible = true;
        examInfo.contestId = item.contestId;
      }
    };
    var showFair = function () {
      scienceFairShowFlag.value = true;
      window.hetaoTrack('chongqin_active_btn_event', {
        type: '科普赛事',
        submitTime: moment().format('YYYY-MM-DD HH:mm:ss')
      });
    };
    var goToUserCenter = function () {
      if (!userService.user) {
        loginService.showLoginDialog();
        return;
      }
      router.push({
        name: 'UserItemList'
      });
    };
    var goCheckDevice = function (record) {
      var queryData = {
        id: record.userExamId,
        contestId: record.contestId
      };
      var queryDataBase64 = window.btoa(JSON.stringify(queryData));
      router.push({
        name: 'DeviceCheck',
        query: {
          qs: queryDataBase64
        }
      });
    };
    var inIframe = isInIframe();
    var onBtnClick = function () {
      var _a;
      if (itemService.item) {
        var item_1 = itemService.item;
        if (item_1.buttonId === 1) {
          // 判断无品牌场景下直接去报名
          if (!SHOW_BRAND) {
            router.push({
              name: 'ItemApply',
              params: {
                id: item_1.contestId
              }
            });
            return;
          }
          // 立即报名
          if (userService.user) {
            router.push({
              name: 'ItemApply',
              params: {
                id: item_1.contestId
              }
            });
          } else {
            loginService.showLoginDialog();
          }
        } else if (item_1.buttonId === 2) {
          // 在btoc iframe中跳转到个人中心 统一通过个人中心处理
          if (inIframe) {
            router.push({
              name: 'UserItemList'
            });
          } else if ((_a = item_1.userSupportCheck) === null || _a === void 0 ? void 0 : _a.deviceCheckConfig) {
            goCheckDevice(item_1);
          } else {
            // 去考试
            showExamInfo(item_1);
          }
        } else if (item_1.buttonId === 3) {
          // 去查分
          router.push({
            name: 'UserItemDetail',
            params: {
              id: item_1.userExamId
            }
          });
        } else if (item_1.buttonId === 4) {
          // 待考试跳转到考试信息页面
          router.push({
            name: 'UserItemList'
          });
        } else if (item_1.buttonId !== 4) {
          // 4,"待考试" 不做逻辑
          _message.error('请刷新页面重试');
        }
      }
    };
    onBeforeUnmount(function () {
      itemService.clearTimer();
    });
    var item = computed(function () {
      return itemService.item;
    });
    return {
      item: item,
      examInfo: examInfo,
      onBtnClick: onBtnClick,
      showFair: showFair,
      goToUserCenter: goToUserCenter,
      hideGetCertification: hideGetCertification,
      shangdongSpecialActive: shangdongSpecialActive,
      chongqinSpecialActive: chongqinSpecialActive,
      scienceFairShowFlag: scienceFairShowFlag,
      showBrand: SHOW_BRAND,
      hideInfoSpecialActive: hideInfoSpecialActive,
      inIframe: inIframe
    };
  }
});